import axios from "axios";
var PwResetHttpServivce = /** @class */ (function () {
    function PwResetHttpServivce() {
        axios.defaults.baseURL = __API_URL__ || "api/";
    }
    PwResetHttpServivce.prototype.updatePw = function (model, token) {
        return axios.put("pwreset/pw", model, {
            headers: {
                "Authorization": "Bearer " + token
            }
        });
    };
    PwResetHttpServivce.prototype.getPolicy = function (token) {
        return axios.get("pwreset/policy", {
            headers: {
                "Authorization": "Bearer " + token
            }
        });
    };
    PwResetHttpServivce.prototype.getVerify = function (token) {
        return axios.get("pwreset/token_state", {
            headers: {
                "Authorization": "Bearer " + token
            }
        });
    };
    PwResetHttpServivce.prototype.confirmRecoveryEmailAdress = function (token) {
        console.log(token);
        return axios.post("pwreset/pw_recovery_mail_addr/confirmation", {}, {
            headers: {
                "Authorization": "Bearer " + token
            }
        });
    };
    PwResetHttpServivce.prototype.sendPw = function (model) {
        return axios.post("pub/token", model);
    };
    return PwResetHttpServivce;
}());
export { PwResetHttpServivce };
export default new PwResetHttpServivce();
